import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/do";
import "rxjs/add/operator/delay";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { User } from "@app/shared/models/user";
import { EBSUser } from "@app/shared/models/ebs-user"
import { distinctUntilChanged } from "rxjs/operators";
@Injectable()
export class AuthenticationService {
  private currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject.asObservable().distinctUntilChanged();
  private currentEBSUserSubject = new BehaviorSubject<EBSUser>({} as EBSUser);
  public currentEBSUser = this.currentEBSUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();
  constructor(private httpClient: HttpClient) { }
  isLoggedInn = true;

  // store the URL so we can redirect after logging in
  redirectUrl: string;
  logout(): void {
    this.isLoggedInn = false;
  }

  isLoggedIn() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      return true;
    } else {
      return false;
    }
  }

  isRoleValid(role: string) {
    if (this.getRole() === role) {
      return true;
    }
  }

  getRole() {
    let role: any;
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      role = JSON.parse(window.sessionStorage.getItem("userDetails"));
      if(role["roles"] != null && role["roles"]["0"] != null && role["roles"]["0"]["code"] != null){
        return role["roles"]["0"]["code"];
      }
    }
  }

  getFormattedRole() {
    let formattedUserRole;
    const userRole = this.getRole();
    if (userRole === 'tech_buyer') {
      formattedUserRole = 'tech-buyer';
    } else if (userRole === 'tech_vendor') {
      formattedUserRole = 'tech-vendor';
    } else if (userRole === 'tech_analyst') {
      formattedUserRole = 'tech-analyst';
    } else if (userRole === 'ecosystm_staff') {
      formattedUserRole = 'ecosystm-staff';
    }
    return formattedUserRole;
  }


  getLoggedUserType() {
    const userRole = this.getRole();
    if (userRole === "tech_buyer") {
      return "tech-buyer";
    } else if (userRole === "tech_vendor") {
      return "tech-vendor";
    } else if (userRole === "tech_analyst") {
      return "tech-analyst";
    } else if (userRole === 'ecosystm_staff') {
      return "ecosystm-staff";
    }
  }

  getRoleName() {
    let role: any;
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      role = JSON.parse(window.sessionStorage.getItem("userDetails"));
      return role["roles"]["0"]["name"];
    }
  }

  getUserId() {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      return JSON.parse(window.sessionStorage.getItem("userDetails")).userId;
    }
  }

  getCommonUserDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      return {
        "Email ID": JSON.parse(window.sessionStorage.getItem("userDetails")).email,
        "User Role": this.getRole()
      };
    } else {
      return null;
    }
  }

  getUserName() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      return (
        JSON.parse(window.sessionStorage.getItem("userDetails")).firstName +
        " " +
        JSON.parse(window.sessionStorage.getItem("userDetails")).lastName
      );
    } else {
      return null;
    }
  }

  login(loginCredentials) {
    return this.httpClient.post("users/login", loginCredentials);
  }

  registerWebPushDevice(queryData) {
    return this.httpClient.put("users/push-notification-subscription", null, { params: queryData });
  }

  resendVerificationEmail(email: string) {
    const params = new HttpParams().set("emailId", email);
    return this.httpClient.get("users/resend-email", { params: params });
  }

  getuserDetails(id: string, accessToken: string) {
    const query = {
      include: [
        "roles", "contactNumbers",
        { organization: "techBuyerOrganization" }
      ]
    };
    const filter = new HttpParams()
      .set("access_token", accessToken)
      .append("filter", JSON.stringify(query));
    return this.httpClient.get(`users/${id}`, { params: filter });
  }

  //side bar component function

  setAuth(user: User) {
    // Save JWT sent from server in localstorage
    // this.jwtService.saveToken(user.token);
    localStorage.setItem('userToken', user.token);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

  setEBSAuth(user: EBSUser) {
    // Save JWT sent from server in localstorage
    // this.jwtService.saveToken(user.token);
    // localStorage.setItem('userToken', user.token);
    // Set current user data into observable
    this.currentEBSUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

  purgeAuth() {
    // Remove JWT from localstorage
    // this.jwtService.destroyToken();
    // localStorage.removeItem('userToken');
    // Set current user to an empty object
    this.currentUserSubject.next(new User());
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }

  purgeEBSAuth() {
    // Remove JWT from localstorage
    // this.jwtService.destroyToken();
    localStorage.removeItem('userToken');
    // Set current user to an empty object
    this.currentEBSUserSubject.next({} as EBSUser);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }
  getCurrentEBSUser(): EBSUser {
    return this.currentEBSUserSubject.value;
  }

  checkBlockListDomain(email, type) {
    return this.httpClient.get(`users/is-black-listed?type=${type}&email=${email}`);
  }

  registerUser(userFormData: object) {
    return this.httpClient.post('users', JSON.stringify(userFormData));
  }

  tokenLogin(accessToken) {
    return this.httpClient.post(`users/tokenLogin?access_token=${accessToken}`, {});
  }

  /**
   * Populates user details
   */
   populate(id: string) {
    if (localStorage.getItem('userToken')) {
      this.httpClient
        .get(`UserRoleViews/get-analyst-profile/${id}`)
        .subscribe(
          (data: User) =>{
            this.currentUserSubject.next(data)
          },
          err => this.purgeAuth()
        );
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication.service.ts